/* eslint-disable no-lone-blocks */
/**
 * @file Banner
 * @author wanzhongyun
 */

import { Button } from 'antd';
import { RootObject, JumpContent } from '../../type';

import './style.less';


const Banner = (props: RootObject["hardwareCoCreationBanner"]) => {
  return (
    <div className='co-creation-banner-wrapper' style={{ background: `url(${props.backImg})` }}>
      <div className='co-creation-banner-content' >
        <div className='co-creation-banner-title'>
          {
            props.title ?? ""
          }
        </div>
        <div className='co-creation-banner-desc'>
          {
            props.content ?? ""
          }
        </div>
        <div className='co-creation-banner-btn-list'>
          {
            props.jumpContent.map((value: JumpContent, index: number) => {
              return (
                <Button className="btn" type="primary" key={index}>
                  <a className="btn_a" href={value.detailLink} target='_blank' rel='noreferrer'>{value.title}</a>
                </Button>
              )
            })
          }
        </div>
      </div>
    </div>
  )
}

export default Banner